import { action } from "@ember/object"
import { inject as service } from "@ember/service"
import Component from "@glimmer/component"
import type { LessonCard } from "@shared/models/card-stack"
import type { Comment } from "@shared/models/comment"
import { handleError } from "cc-frontend/error-handling"
import FindDoc from "cc-frontend/helpers/find-doc"
import type LessonEditor from "cc-frontend/services/lesson-editor"
import type { ModelsNeededForFirstEdit } from "cc-frontend/services/lesson-editor"
import { use } from "ember-could-get-used-to-this"

interface Sig {
  Args: {
    card: LessonCard
    cardStackId: string
    modelsNeededForFirstEdit: ModelsNeededForFirstEdit
    comment: Comment
  }
}

export default class CommentComponent extends Component<Sig> {
  @service lessonEditor!: LessonEditor

  @use commenter = new FindDoc(() => ["user-summary", this.args.comment.attributes.commenterId])

  get commenterName() {
    if (this.commenter.content === null) return ""
    return (
      this.commenter.content.attributes.firstName + " " + this.commenter.content.attributes.lastName
    )
  }

  @action
  removeComment() {
    window
      .swal({
        title: "Delete Comment?",
        text: "Are you sure you want to delete this comment?",
        type: "warning",
        showCancelButton: true,
      })
      .then(() => {
        this.lessonEditor.deleteCardComment(
          this.args.modelsNeededForFirstEdit,
          this.args.cardStackId,
          this.args.card.id,
          this.args.comment,
          this.commenterName
        )
      })
      .catch((error) => {
        if (error instanceof Error) handleError(error)
      })
  }
}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    "Planner::CardStacks::Cards::Parts::Comment": typeof CommentComponent
  }
}
